/**
 * ─────────────────────────────────────────────────────────────────────────────
 *  A navegação do dashboard
 *
 *  As capturas parecem dezasseis ecrãs soltos, mas não são. Treze deles trazem
 *  uma barra de pastilhas no topo, e as pastilhas repetem-se em quatro
 *  conjuntos — que é a estrutura verdadeira:
 *
 *      Programa · Explore · Realize · Dados
 *
 *  Os três primeiros ficheiros das capturas (avanço por frente, avanço geral e
 *  matriz de risco) não têm barra nenhuma: são recortes de Excel e de
 *  PowerPoint, não ecrãs. O conteúdo deles encaixa dentro de *Pontos de
 *  Atenção* e de *Riscos e Problemas*, que é onde a barra os coloca.
 *
 *  Os nomes dos grupos são os do próprio método de implantação SAP — Explore e
 *  Realize são fases do Activate. Traduzi-los daria nomes que ninguém no
 *  projeto usa em voz alta.
 * ─────────────────────────────────────────────────────────────────────────────
 */

export interface PaginaDash {
  slug: string;
  titulo: string;
}

export interface GrupoDash {
  slug: string;
  titulo: string;
  paginas: PaginaDash[];
}

export const GRUPOS: readonly GrupoDash[] = [
  {
    slug: "programa",
    titulo: "Programa",
    paginas: [
      { slug: "status-executivo", titulo: "Status Executivo" },
      { slug: "status-operacional", titulo: "Status Operacional" },
      { slug: "riscos-problemas", titulo: "Riscos e Problemas" },
      // PL-003 (15/09). Lê a coluna "Recursos" do Cronograma — é do programa,
      // não de uma fase, por isso vive aqui.
      { slug: "alocacao-recursos", titulo: "Alocação de recursos" },
    ],
  },
  {
    slug: "explore",
    titulo: "Explore",
    paginas: [
      { slug: "workshops", titulo: "Workshops" },
      { slug: "parking-lot", titulo: "Parking Lot" },
      { slug: "gaps", titulo: "GAPs" },
      { slug: "requisitos", titulo: "Requisitos" },
      { slug: "decisoes", titulo: "Decisões Chave" },
    ],
  },
  {
    slug: "realize",
    titulo: "Realize",
    paginas: [
      { slug: "change-requests", titulo: "Change Request" },
      { slug: "ricefw", titulo: "Desenvolvimentos" },
      { slug: "configuracao", titulo: "Configuração" },
      { slug: "testes", titulo: "Testes" },
    ],
  },
  {
    slug: "dados",
    titulo: "Dados",
    paginas: [
      { slug: "status-sit", titulo: "Status" },
      { slug: "agenda-bdm", titulo: "Agenda BDM" },
      { slug: "pendencias", titulo: "Pendências" },
    ],
  },
  // ⚠ Grupo próprio desde 14/09, a pedido do cliente — saiu do Realize. Com uma
  // só página, a barra de pastilhas de segundo nível não aparece (`NavGrupo`
  // só a desenha a partir de duas), e é isso que se quer: o separador É o painel.
  {
    slug: "legados",
    titulo: "Legados",
    paginas: [{ slug: "visao-geral", titulo: "Legados" }],
  },
] as const;

/** O ecrã de entrada. `/dashboard` sozinho não é um destino. */
export const ROTA_INICIAL = "/dashboard/programa/status-executivo";

export function encontrarPagina(grupo?: string, pagina?: string) {
  const g = GRUPOS.find((x) => x.slug === grupo);
  return { grupo: g, pagina: g?.paginas.find((p) => p.slug === pagina) };
}
